import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { updateDoc, doc } from "firebase/firestore";
import { getDb } from "../../util/Constants";
import { Spinner } from "reactstrap";
import { imageMap } from "../../util/Constants";


export default function DraggableImagesMini8({
  row,
  isEditing,
  editedSequence,
  setEditedSequence,
}) {
  const sequence = isEditing ? editedSequence : row.sequence || [];

  const onDragEnd = (result) => {
    if (!result.destination) return;
    const reordered = Array.from(sequence);
    const [removed] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, removed);
    setEditedSequence(reordered);
  };
  if (!isEditing) {
    // 🔒 Not editable, just display images statically
    return (
      <div
        className="draggable-container"
        style={{ display: "flex", gap: 62, flexWrap: "wrap" }}
      >
        {sequence.map((key, idx) => (
          <div
            key={key + idx}
            className="draggable-image-mini8-add"
            style={{ cursor: "default" }}
          >
            <img
              src={imageMap[key]?.default}
              alt={key}
              width={60}
              height={60}
              className="draggable-image-mini8-img"
              title={key}
            />
            <div className="draggable-image-mini8-key">{key}</div>
          </div>
        ))}
      </div>
    );
  }
  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId={`droppable-${row.id}`} direction="horizontal">
        {(provided) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className="draggable-container"
            style={{ gap: 62, flexWrap: "wrap" }}
          >
            {sequence.map((key, idx) => (
              <Draggable key={key + idx} draggableId={key + idx} index={idx}>
                {(provided2, snapshot) => (
                  <div
                    ref={provided2.innerRef}
                    {...provided2.draggableProps}
                    {...provided2.dragHandleProps}
                    className={
                      "draggable-image-mini8-add" +
                      (snapshot.isDragging ? " dragging" : "")
                    }
                    style={provided2.draggableProps.style}
                  >
                    <img
                      src={imageMap[key]?.default}
                      alt={key}
                      width={60}
                      height={60}
                      className="draggable-image-mini8-img"
                      title={key}
                    />
                    <div className="draggable-image-mini8-key">{key}</div>
                  </div>
                )}
              </Draggable>
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}
